import { Subject } from 'rxjs';
import { Transition, TransitionService } from '@uirouter/core';
import { Injectable } from '@angular/core';

@Injectable()
export class FiStateChangeService {
    onBefore$ = new Subject<Transition>();
    onStart$ = new Subject<Transition>();
    onFinish$ = new Subject<Transition>();
    onSuccess$ = new Subject<Transition>();
    onError$ = new Subject<Transition>();
    onCancel$ = new Subject<Transition>();

    initTransitionHooks(transitionService: TransitionService) {
        transitionService.onBefore(undefined, (transition) => {
            this.onBefore$.next(transition);
        });
        transitionService.onStart(undefined, (transition) => {
            this.onStart$.next(transition);
        });
        transitionService.onFinish(undefined, (transition) => {
            this.onFinish$.next(transition);
        });
        transitionService.onSuccess(undefined, (transition) => {
            this.onSuccess$.next(transition);
        });
        transitionService.onError(undefined, (transition) => {
            this.onError$.next(transition);
        });
    }

    triggerTransitionCancelled() {
        this.onCancel$.next(undefined);
    }
}
